
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10.32","height":"6.574"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 2149","d":"M.707.707L5.16 5.16l1.855-1.853 2.598-2.6","fill":"none","stroke":"#222","stroke-width":"2"}})])
          )
        }
      }
    